import React from 'react'
import { CreateJobPositionFormTestContainer } from '../../containers/Officer/CreateJobPositionFormTestContainer'
export const CreateJobPositionFormTestPage = () => {
  return (
    <CreateJobPositionFormTestContainer />
  )
}
